export default __webpack_public_path__ + "static/O0191-bd51e0b9390e138e34bef4eca046c905.png";